/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { UpdateUserPreferencesOptions, UpdateUserPreferencesStatus200, UpdateUserPreferencesStatus422 } from '../models/UpdateUserPreferences'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateUserPreferences } from '../clients/axios/updateUserPreferences'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateUserPreferencesMutationKey = () => [{ url: '/user/preferences' }] as const

export function updateUserPreferencesMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = updateUserPreferencesMutationKey()
  return mutationOptions<UpdateUserPreferencesStatus200, ResponseErrorConfig<UpdateUserPreferencesStatus422>, UpdateUserPreferencesOptions, TContext>({
    mutationKey,
    mutationFn: async({ body }) => {
      return await updateUserPreferences({ ...config, body, throwOnError: true })
    },
  })
}

/**
 * @summary Update Preferences
 * {@link /user/preferences}
 */
export function useUpdateUserPreferences<TContext>(options: {
  mutation?: UseMutationOptions<UpdateUserPreferencesStatus200, ResponseErrorConfig<UpdateUserPreferencesStatus422>, UpdateUserPreferencesOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? updateUserPreferencesMutationKey()

  const baseOptions = updateUserPreferencesMutationOptions(config) as UseMutationOptions<UpdateUserPreferencesStatus200, ResponseErrorConfig<UpdateUserPreferencesStatus422>, UpdateUserPreferencesOptions, TContext>

  return useMutation<UpdateUserPreferencesStatus200, ResponseErrorConfig<UpdateUserPreferencesStatus422>, UpdateUserPreferencesOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<UpdateUserPreferencesStatus200, ResponseErrorConfig<UpdateUserPreferencesStatus422>, UpdateUserPreferencesOptions, TContext>
}
